/**
 * @generated SignedSource<<1bd0c6687c96286c769cbee2aa2fd430>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ButtonTextStyleType = "SENTENCE_CASE" | "UPPERCASE" | "%future added value";
export type IconType = "ACTIVITY" | "AIRPLAY" | "ALERT_CIRCLE" | "ALERT_OCTAGON" | "ALERT_TRIANGLE" | "ALIGN_CENTER" | "ALIGN_JUSTIFY" | "ALIGN_LEFT" | "ALIGN_RIGHT" | "ANCHOR" | "APERTURE" | "ARCHIVE" | "ARROW_DOWN" | "ARROW_DOWN_CIRCLE" | "ARROW_DOWN_LEFT" | "ARROW_DOWN_RIGHT" | "ARROW_LEFT" | "ARROW_LEFT_CIRCLE" | "ARROW_RIGHT" | "ARROW_RIGHT_CIRCLE" | "ARROW_UP" | "ARROW_UP_CIRCLE" | "ARROW_UP_LEFT" | "ARROW_UP_RIGHT" | "AT_SIGN" | "AWARD" | "BAR_CHART" | "BAR_CHART_2" | "BATTERY" | "BATTERY_CHARGING" | "BELL" | "BELL_FILL" | "BELL_OFF" | "BLUETOOTH" | "BOLD" | "BOOK" | "BOOKMARK" | "BOOK_OPEN" | "BOX" | "BRIEFCASE" | "CALENDAR" | "CAMERA" | "CAMERA_OFF" | "CAST" | "CHECK" | "CHECK_CIRCLE" | "CHECK_SQUARE" | "CHEVRONS_DOWN" | "CHEVRONS_LEFT" | "CHEVRONS_RIGHT" | "CHEVRONS_UP" | "CHEVRON_DOWN" | "CHEVRON_LEFT" | "CHEVRON_RIGHT" | "CHEVRON_UP" | "CHROME" | "CIRCLE" | "CLIPBOARD" | "CLOCK" | "CLOUD" | "CLOUD_DRIZZLE" | "CLOUD_LIGHTNING" | "CLOUD_OFF" | "CLOUD_RAIN" | "CLOUD_SNOW" | "CODE" | "CODEPEN" | "CODESANDBOX" | "COFFEE" | "COLUMNS" | "COMMAND" | "COMPASS" | "COPY" | "CORNER_DOWN_LEFT" | "CORNER_DOWN_RIGHT" | "CORNER_LEFT_DOWN" | "CORNER_LEFT_UP" | "CORNER_RIGHT_DOWN" | "CORNER_RIGHT_UP" | "CORNER_UP_LEFT" | "CORNER_UP_RIGHT" | "CPU" | "CREDIT_CARD" | "CROP" | "CROSSHAIR" | "CUSTOM_CART" | "CUSTOM_CONCIERGE" | "CUSTOM_EXPERIENCES" | "CUSTOM_FEED" | "CUSTOM_PROFILE" | "CUSTOM_SHOP" | "DATABASE" | "DELETE" | "DISC" | "DIVIDE" | "DIVIDE_CIRCLE" | "DIVIDE_SQUARE" | "DOLLAR_SIGN" | "DOWNLOAD" | "DOWNLOAD_CLOUD" | "DRIBBBLE" | "DROPLET" | "EDIT" | "EDIT_2" | "EDIT_3" | "EXTERNAL_LINK" | "EYE" | "EYE_OFF" | "FACEBOOK" | "FAST_FORWARD" | "FEATHER" | "FIGMA" | "FILE" | "FILE_MINUS" | "FILE_PLUS" | "FILE_TEXT" | "FILM" | "FILTER" | "FLAG" | "FOLDER" | "FOLDER_MINUS" | "FOLDER_PLUS" | "FOR_YOU" | "FRAMER" | "FROWN" | "GIFT" | "GITHUB" | "GITLAB" | "GIT_BRANCH" | "GIT_COMMIT" | "GIT_MERGE" | "GIT_PULL_REQUEST" | "GLOBE" | "GRID" | "HARD_DRIVE" | "HASH" | "HEADPHONES" | "HEART" | "HELP_CIRCLE" | "HEXAGON" | "HOME" | "IMAGE" | "INBOX" | "INFO" | "INSTAGRAM" | "ITALIC" | "KEY" | "LAYERS" | "LAYOUT" | "LIFE_BUOY" | "LINK" | "LINKEDIN" | "LINK_2" | "LIST" | "LOADER" | "LOCK" | "LOG_IN" | "LOG_OUT" | "MAIL" | "MAP" | "MAP_PIN" | "MAXIMIZE" | "MAXIMIZE_2" | "MEH" | "MENU" | "MESSAGE_CIRCLE" | "MESSAGE_SQUARE" | "MESSAGE_SQUARE_FILL" | "MIC" | "MIC_OFF" | "MINIMIZE" | "MINIMIZE_2" | "MINUS" | "MINUS_CIRCLE" | "MINUS_SQUARE" | "MONITOR" | "MOON" | "MORE_HORIZONTAL" | "MORE_VERTICAL" | "MOUSE_POINTER" | "MOVE" | "MUSIC" | "NAVIGATION" | "NAVIGATION_2" | "OCTAGON" | "PACKAGE" | "PAPERCLIP" | "PAUSE" | "PAUSE_CIRCLE" | "PEN_TOOL" | "PERCENT" | "PHONE" | "PHONE_CALL" | "PHONE_FORWARDED" | "PHONE_INCOMING" | "PHONE_MISSED" | "PHONE_OFF" | "PHONE_OUTGOING" | "PIE_CHART" | "PLAY" | "PLAY_CIRCLE" | "PLUS" | "PLUS_CIRCLE" | "PLUS_SQUARE" | "POCKET" | "POWER" | "PRINTER" | "RADIO" | "REFRESH_CCW" | "REFRESH_CW" | "REPEAT" | "REWIND" | "ROTATE_CCW" | "ROTATE_CW" | "RSS" | "SAVE" | "SCISSORS" | "SEARCH" | "SEND" | "SERVER" | "SETTINGS" | "SHARE" | "SHARE_2" | "SHIELD" | "SHIELD_OFF" | "SHOPPING_BAG" | "SHOPPING_CART" | "SHUFFLE" | "SIDEBAR" | "SKIP_BACK" | "SKIP_FORWARD" | "SLACK" | "SLASH" | "SLIDERS" | "SMARTPHONE" | "SMILE" | "SPEAKER" | "SQUARE" | "STAR" | "STOP_CIRCLE" | "SUN" | "SUNRISE" | "SUNSET" | "TABLE" | "TABLET" | "TAG" | "TARGET" | "TERMINAL" | "THERMOMETER" | "THUMBS_DOWN" | "THUMBS_UP" | "TOGGLE_LEFT" | "TOGGLE_RIGHT" | "TOOL" | "TRASH" | "TRASH_2" | "TRELLO" | "TRENDING_DOWN" | "TRENDING_UP" | "TRIANGLE" | "TRUCK" | "TV" | "TWITCH" | "TWITTER" | "TYPE" | "UMBRELLA" | "UNDERLINE" | "UNLOCK" | "UPLOAD" | "UPLOAD_CLOUD" | "USER" | "USERS" | "USER_CHECK" | "USER_MINUS" | "USER_PLUS" | "USER_X" | "VIDEO" | "VIDEO_OFF" | "VOICEMAIL" | "VOLUME" | "VOLUME_1" | "VOLUME_2" | "VOLUME_2_FILL" | "VOLUME_X" | "VOLUME_X_FILL" | "WATCH" | "WIFI" | "WIFI_OFF" | "WIND" | "X" | "X_CIRCLE" | "X_OCTAGON" | "X_SQUARE" | "YOUTUBE" | "ZAP" | "ZAP_OFF" | "ZOOM_IN" | "ZOOM_OUT" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ButtonStyleCard_brand$data = {
  readonly appConfig: {
    readonly buildTheme: {
      readonly buttonBorderThickness: number | null;
      readonly buttonCartIcon: IconType | null;
      readonly buttonCornerRadius: number | null;
      readonly buttonTextStyle: ButtonTextStyleType | null;
      readonly id: string;
    };
    readonly id: string;
  };
  readonly " $fragmentType": "ButtonStyleCard_brand";
};
export type ButtonStyleCard_brand$key = {
  readonly " $data"?: ButtonStyleCard_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"ButtonStyleCard_brand">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ButtonStyleCard_brand",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandAppConfigType",
      "kind": "LinkedField",
      "name": "appConfig",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "BrandAppConfigBuildThemeType",
          "kind": "LinkedField",
          "name": "buildTheme",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "buttonBorderThickness",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "buttonCartIcon",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "buttonCornerRadius",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "buttonTextStyle",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};
})();

(node as any).hash = "9e53f6dd708c0f439f71cee5e4c02072";

export default node;
